import React, { Component } from "react";
import Listing from "../pages/Listing";
import Pdp from "../pages/Pdp";
import BrandPage from "../pages/BrandPage";
import { isPdpPage, deduceValuesFromPipedData } from "../utils";
import NotFound from "../component/routingComponent/NotFound";
import { pageType, GETTYPE_PAGEWISE_VALUES } from "../constants";

class UiRoutingComponent extends Component {
  static selectedComponent() {
    const getType = window && window.getType;
    const currentPage =
      (window.history &&
        window.history.state &&
        window.history.state.state &&
        window.history.state.state.currentPage &&
        window.history.state.state.currentPage) ||
      "";
    const isCurrentStatePdp = currentPage === pageType.pdp;
    const isCurrentStateListing = currentPage === pageType.listing;
    const documentType = getType && getType.documentType;
    const { type } = deduceValuesFromPipedData(getType && getType.type);
    const finalType = documentType || type;
    const cidOverride =
      window.location.search.indexOf("cid") > -1 ? "Collection" : "";
    const pdpFallBack = isPdpPage(window.location.pathname) ? "Style" : "";
    return (
      cidOverride ||
      (isCurrentStatePdp && "Style") ||
      (isCurrentStateListing && "Collection") ||
      pdpFallBack ||
      finalType
    );
  }
  render() {
    const { props } = this;
    const type = UiRoutingComponent.selectedComponent();

    switch (true) {
      case GETTYPE_PAGEWISE_VALUES.LISTING.includes(type):
        return <Listing {...props} />;
      case GETTYPE_PAGEWISE_VALUES.PDP.includes(type):
        return <Pdp {...props} />;
      case GETTYPE_PAGEWISE_VALUES.MASTER_TEMPLATE.includes(type):
        return <BrandPage {...props} />;
      default:
        return <NotFound {...props} />;
    }
  }
}
export default UiRoutingComponent;



// WEBPACK FOOTER //
// ./src/App/UiRoutingComponent.js